import { useCallback, useEffect, useLayoutEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'reduxTyped'

import { addPrompt } from 'common/core/actions/uiActions'
import { getUserId } from 'common/core/selectors/appSelectors'
import { useUsercentrics } from 'utils/commonHooks'

import { engagementService } from './brazeEngagementService'
import { getPrompt } from './utils'

const USERCENTRICS_BRAZE_NAME = 'Braze'
const SESSION_BRAZE_KEY = 'braze'

export const useEngagementService = (isSilent: boolean = false) => {
  const { usercentricsServicesInfo, updateServicesConsents } =
    useUsercentrics(USERCENTRICS_BRAZE_NAME)
  const isBrazeProvided = usercentricsServicesInfo[USERCENTRICS_BRAZE_NAME]?.status ?? false
  const userId = useAppSelector(getUserId)
  const brazeId = usercentricsServicesInfo[USERCENTRICS_BRAZE_NAME]?.id ?? ''
  const dispatch = useAppDispatch()

  const sessionBrazeValue = sessionStorage.getItem(SESSION_BRAZE_KEY)
  const shouldShowPrompt =
    userId &&
    !isBrazeProvided &&
    usercentricsServicesInfo[USERCENTRICS_BRAZE_NAME] &&
    !isSilent &&
    !sessionBrazeValue &&
    !engagementService.isPaused

  const handleActivateBraze = useCallback(
    () => updateServicesConsents([{ id: brazeId, consent: true }]),
    [brazeId, updateServicesConsents],
  )

  useEffect(() => {
    if (shouldShowPrompt) {
      const prompt = getPrompt(handleActivateBraze)
      sessionStorage.setItem(SESSION_BRAZE_KEY, String(true))
      dispatch(addPrompt(prompt))
    }
  }, [dispatch, handleActivateBraze, shouldShowPrompt])

  useLayoutEffect(() => {
    if (!isBrazeProvided || !userId) {
      engagementService.dispose()

      return
    }

    engagementService.init(userId)
  }, [isBrazeProvided, userId])

  return engagementService
}
